export enum ServerUrls {
ACCOUNTS_AUTH = "https://accounts.spotify.com/api/",
ARTIST_SEARCH = "https://api.spotify.com/v1/",
ARTIST_ALBUM_SEARCH = "https://api.spotify.com/v1/artists/"
}
